/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { IoPricetagOutline } from "react-icons/io5";
import StarIcon from "@mui/icons-material/Star";
import "./contactverifier.css";
import parse from "html-react-parser";
import { LuContact } from "react-icons/lu";
import { connect } from "react-redux";
import Card from "react-bootstrap/Card";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { Grid, Toolbar, Divider, Tooltip } from "@mui/material";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import axios from "axios";
import {
  TbWorld,
  TbAddressBook,
  TbMapPinCode,
  TbBrandLinkedin,
  TbBriefcase,
} from "react-icons/tb";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import InfiniteScroll from "react-infinite-scroll-component";
import PermContactCalendarOutlinedIcon from "@mui/icons-material/PermContactCalendarOutlined";
import Key from "../../clientVariables.json";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import Search from "../Companies/Searchcontact";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ContactActivity from "./ContactActivity";
import UpdateCompanyContact from "./UpdateCompanyContact";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import { companiesManagementSelector } from "./redux/selector";
import "./contactverifier.css";
import FilterListIcon from "@mui/icons-material/FilterList";
import LoadingSkeleton from "../loadingSkeletons/LoadingList";

export const CompanyJobs = ({
  companyJobs,
  getCOmpanyJobs,
  jobshasmore,
  selectedJobId,
  getJobDetail,
  jobsLoading,
  jobsLoadComplete,
  hasJobs,
}) => {
  const scrollRef = useRef(null);
  const [email, setEmail] = useState("");
  const showSkeleton = !jobsLoadComplete || (jobsLoading && (!companyJobs || companyJobs.length === 0));


  // const paperStyles = {
  //   borderRadius: "8px",
  //   height: "100vh",
  //   overflow: "auto"
  // };


  return (
    <Paper elevation={2} sx={{ height: "100%", flex: 1, minHeight: 0, width: "100%", display: "flex", flexDirection: "column", borderRadius: "8px", overflow: "hidden" }}>
      <Toolbar
        sx={{
          flexShrink: 0,
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          minHeight: "42px !important",
          bgcolor: "#fff",
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        }}
      >
        <Box
          sx={{
            flex: "1 1 100%",
          }}
        >
          <Typography
            sx={{ fontWeight: 500, margin: 0 }}
            // variant="h6"
            paragraph
            id="tableTitle"
            component="div"
          >
            Jobs
          </Typography>
        </Box>
      </Toolbar>
      <Divider sx={{ margin: 0 }} />
      <Box
        id="companyJobsScrollableDiv"
        ref={scrollRef}
        sx={{
          flex: 1,
          overflowY: "auto",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        {showSkeleton ? (
          <LoadingSkeleton />
        ) : !hasJobs || !companyJobs?.length ? (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              width: "100%",
              minHeight: "100%",
            }}
          >
            <Typography variant="subtitle1" color="text.secondary" sx={{ m: 0 }}>
              No Jobs Found
            </Typography>
          </Box>
        ) : (
          <InfiniteScroll
            dataLength={companyJobs?.length || 0}
            next={getCOmpanyJobs}
            hasMore={Boolean(jobshasmore)}
            className="infinityscroll"
            style={{ overflow: "hidden" }}
            scrollableTarget="companyJobsScrollableDiv"
            pullDownToRefreshThreshold={50}
            loader={
              jobsLoading && jobshasmore && companyJobs?.length > 0 ? (
                <LoadingSkeleton />
              ) : null
            }
          >
            {companyJobs.map((job) => (
              <div
                key={job.id}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (String(selectedJobId) === String(job.id)) return;
                  getJobDetail(job.id);
                }}
              >
                <List
                  sx={{
                    width: "100%",
                    bgcolor: "background.paper",
                  }}
                  style={{
                    paddingBottom: "0px",
                    paddingTop: "0px",
                    marginBottom: "10px",
                    backgroundColor: selectedJobId === job.id ? "rgba(25, 118, 210, 0.08)" : "white",
                  }}
                >
                  <ListItem alignItems="flex-start" className="jobslist">
                    {/* Avatar Section */}
                    <ListItemAvatar sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <Avatar style={{ backgroundColor: "rgb(169, 169, 169)" }}>
                        <BusinessCenterIcon />
                      </Avatar>
                    </ListItemAvatar>

                    {/* Job Details */}
                    <ListItemText
                      primary={
                        <div>
                          {/* Job Title */}
                          <Typography
                            variant="body2"
                            noWrap
                            sx={{
                              fontSize: "12px",
                              fontWeight: 700,
                              marginTop: "7px",
                            }}
                            title={job?.title}
                          >
                            {job?.title}
                          </Typography>

                          {/* Timestamp & Location in the same line */}
                          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", marginTop: "3px", color: "#757575", paddingBottom: "12px" }}>
                            <span>
                              {job?.is_remote === 1
                                ? "Remote"
                                : job?.location
                                  ? job.location
                                  : "N/A"}
                            </span>
                            <span>{moment(job.modified).fromNow()}</span>

                          </div>
                        </div>
                      }
                    />
                  </ListItem>
                </List>

                {/* Divider Below Each Job */}
                {/* <Divider /> */}
              </div>
            ))}
          </InfiniteScroll>
        )}
      </Box>
    </Paper>
  );
};
export default CompanyJobs;
